import { useTranslation } from 'react-i18next';

const nearbyPlaces = [
  { name: 'Femés', distance: '4.7 km' },
  { name: 'Playa de Janubio', distance: '6.8 km' },
  { name: 'Cortijo Viejo', distance: '6.8 km' },
  { name: 'Quemada Beach', distance: '7.7 km' },
  { name: 'Playa del Paso', distance: '7.9 km' },
  { name: 'Mácher', distance: '8.0 km' },
];

export default function BuenlugarMap() {
  const { t } = useTranslation();

  return (
    <section id="location" className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('map_subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">Yaiza, Lanzarote</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2 rounded-lg overflow-hidden h-[350px] md:h-[450px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55875.236789123!2d-13.7955!3d28.9523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc4623b4e5e5e5e5%3A0x5e5e5e5e5e5e5e5e!2sYaiza%2C+Lanzarote!5e0!3m2!1ses!2ses!4v1690000000000!5m2!1ses!2ses"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Villa Buenlugar location in Yaiza, Lanzarote"
              className="rounded-lg"
            ></iframe>
          </div>

          <div className="bg-background-50 rounded-lg p-5 md:p-6 flex flex-col">
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-4">{t('map_nearby')}</h3>
            <div className="space-y-0 flex-1">
              {nearbyPlaces.map((place) => (
                <div
                  key={place.name}
                  className="flex items-center justify-between py-3 border-b border-background-200 last:border-b-0"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                      <i className="ri-map-pin-line text-sm"></i>
                    </span>
                    <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{place.name}</span>
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{place.distance}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}